var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6,
    width: 41,
    height: 41,
    rx: 5.5,
    stroke: "#003366",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3065 32.2349H22.9112C22.8411 32.5655 22.8071 32.9379 22.8071 33.3544C22.8071 33.7699 22.8422 34.1525 22.9112 34.5H32.7266C32.7956 34.1706 32.8307 33.7925 32.8307 33.368C32.8307 32.9424 32.7956 32.5655 32.7266 32.2349H30.9302L29.3941 32.2598L29.4201 30.5154V17.6302C29.0386 17.543 28.6085 17.5 28.1308 17.5C27.6531 17.5 27.2331 17.5441 26.8686 17.6302C26.0525 19.4527 24.4292 21.1189 22 22.629C22.1392 23.358 22.5207 23.8957 23.1456 24.2432C24.6726 23.5663 25.9223 22.629 26.8947 21.4313C26.8075 23.2538 26.7645 24.3043 26.7645 24.5816V30.5177L26.7905 32.2621L25.3065 32.2349Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.5c2fa87891499e053c244be63c9a9e71.svg";
export { ForwardRef as ReactComponent };